import { render, staticRenderFns } from "./temperatureComp.vue?vue&type=template&id=80b193ee&scoped=true"
import script from "./temperatureComp.vue?vue&type=script&lang=js"
export * from "./temperatureComp.vue?vue&type=script&lang=js"
import style0 from "./temperatureComp.vue?vue&type=style&index=0&id=80b193ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b193ee",
  null
  
)

export default component.exports